import { TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react';
import FieldFormControl from '../FieldFormControl';
import { useClientSchemaContext } from '@/context/clientSchemaContext';

const ContactTextField = ({ field, index, disabled }) => {
	const { getFieldProps, values, setFieldValue, getFieldHelpers, getFieldMeta } =
		useFormikContext();
	const { isProspect } = useClientSchemaContext();

	const { onBlur: onFieldBlur, ...fieldProps } = getFieldProps(field.name);

	const { setTouched } = getFieldHelpers(field.name);

	const [name, setName] = useState(values.contacts?.[index]?.[field.fieldName] ?? '');

	useEffect(() => {
		setName(values.contacts?.[index]?.[field.fieldName] ?? '');
	}, [values.contacts?.[index]?.[field.fieldName]]);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	const required = field.mandatory[isProspect ? 'prospect' : 'client'];
	return (
		<FieldFormControl
			{...{
				error,
				disabled: disabled,
				currentValue: name,
				errorMessage,
				field,
			}}
		>
			<TextField
				fullWidth
				{...fieldProps}
				value={name}
				onChange={(e) => setName(e.target.value)}
				{...(field.name.includes('Email') && { type: 'email' })}
				onBlur={async (e) => {
					setFieldValue(field.name, name);
					setTimeout(() => {
						onBlur(e);
					}, 100);
				}}
				{...{ error, disabled, required }}
			/>
		</FieldFormControl>
	);
};

export default ContactTextField;
